import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import * as ScreeningActions from '@app/store/screening/screening.actions';
import { ISearchTrades } from '@shared/interfaces/statusTrades.interface';
import { StatusTradesEnum } from '@app/ips/models/enum/status-trades.enum';
import { ScreeningStepManager } from '../../utils/step-manager.util';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./_search-result.component.sass'],
})
export class SearchResultComponent {
  @Input() data: ISearchTrades[] = [];
  @Input() code: string;
  @Input() noRegisters: boolean;
  @Input() mainRoute = '';
  canClick = [StatusTradesEnum.New, StatusTradesEnum.AwaitingAnalysis];

  constructor(private _store: Store, private _router: Router) { }

  goRecord(idTrade: string, idOperation: string, idSubCategory: string, screeningStep: string, isDiverge?: boolean) {
    const payload: ScreeningActions.ScreeningStateModel = {
      idTrade,
      idOperation,
      idSubCategory,
      postalCode: '',
      screeningStep,
    };
    const nextStep = ScreeningStepManager.nextStep(screeningStep, isDiverge);
    this._store.dispatch(new ScreeningActions.SetTrade(payload));
    this._router.navigate([this.mainRoute, 'triagem', 'passo', nextStep]);
  }

  trackByFn(index: number): number {
    return index;
  }
}
